import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import Free from '../../../../../../../public/assets/icons/freeGiftText.svg';
import FreeNeurons from '../../../../../../../public/assets/icons/freeNeuronsText.svg';
import GiftText from '../../../../../../../public/assets/icons/giftText.svg';
import More from '../../../../../../../public/assets/icons/moreGifts.svg';

export const OpenFeedComponent = styled(More)<JSX.IntrinsicElements['svg']>`
	grid-area: btn;
	align-self: center;
	justify-self: center;
	transition: filter 0.2s, transform 0.1s;
	color: var(--color-white);

	@media (hover: hover), (-moz-touch-enabled: 0), (pointer: fine) {
		&:hover {
			filter: drop-shadow(2px 2px 8px var(--color-white-07));
		}
	}

	@media screen and (max-width: 500px) {
		display: none;
	}

	@media (hover: hover) {
		&:hover {
			transform: scale(1.2);
		}
	}
`;

export const OpenFeedMobileComponentBg = css`
	right: 10px;

	&::after {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 110%;
		height: 110%;
		z-index: -1;
		background: var(--blur-bg);
		opacity: unset;
		filter: blur(15px);
	}
`;

export const FreeGift = styled(Free)<JSX.IntrinsicElements['svg']>`
	position: absolute;
	bottom: -15px;
	display: none;
	left: 50%;
	transform: translate(-50%);

	@media screen and (max-width: 500px) {
		display: block;
	}
`;

export const GetFreeGift = styled(FreeNeurons)<JSX.IntrinsicElements['svg']>`
	position: absolute;
	bottom: -30px;
	display: none;
	left: -25px;

	@media screen and (max-width: 500px) {
		display: block;
	}
`;

export const Gift = styled(GiftText)<JSX.IntrinsicElements['svg']>`
	position: absolute;
	bottom: 0px;
	display: none;
	left: 50%;
	transform: translate(-50%);

	@media screen and (max-width: 500px) {
		display: block;
	}
`;
